import http from '@/communication/AuthConnection'

export default ({_id, idx}) => {
  return http.delete(`/v1/occupation/${_id}`)
    .then(pData => idx)
}



// WEBPACK FOOTER //
// ./src/brain/record/occupation/RemoveOccupationList.js